import axios from "axios";

export default {

    data: () => ({
        home_info: '',
    }),

    mounted() {
        this.get_home()
    },

    methods: {
        async get_home() {
            await axios({
                method: "GET",
                url: "/",
                headers: {
                    token: sessionStorage.getItem("token")
                },
            })
                .then((res) => {
                    console.log(res.data);
                    this.home_info = res.data
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        }
    }
};